import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST} from '@/api/constants'

export default class Limit extends ApiBase {
    constructor(store) {
        const path = `${ACTIVE_BASE_REST}/security/limit`
        super(store, path)
    }
}